import { Injectable } from '@angular/core';
import { CustomsModel } from '@shared/model/customs.model';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CustomsService {

  private customs= new BehaviorSubject<CustomsModel[]>(null);
  private customsFirstAndLast= new BehaviorSubject<CustomsModel[]>(null);
  private showCustomsCreate = new BehaviorSubject<boolean>(false);
 constructor() { }
 sendCustoms(customsModel: CustomsModel[]) {
   localStorage.setItem('customs', JSON.stringify(customsModel));
   this.customs.next( customsModel );
 }
 getCustoms(): Observable<CustomsModel[]>{
   return this.customs.asObservable();
 }
 sendShowCustomsCreate(statusShowCustomsCreate){
   this.showCustomsCreate.next( statusShowCustomsCreate );
 }
 getShowCustomsCreate(): Observable<boolean>{
   return this.showCustomsCreate.asObservable();
 }
 sendFistAndLastCustoms(customsModel: CustomsModel[]) {
   this.customsFirstAndLast.next( customsModel );
 }
 getFistAndLastCustoms(): Observable<CustomsModel[]>{
   return this.customsFirstAndLast.asObservable();
 }
}
